import React from 'react';
import { render } from 'react-dom';
import SidebarRicerca from './ricerca/SidebarRicerca';
import ManageMappa from './ricerca/ManageMappa';

document.addEventListener('DOMContentLoaded', () => {
	const manageMappa = new ManageMappa();
	manageMappa.init();
	render(
		<SidebarRicerca />,
		document.getElementById('sidebar-ricerca-container')
	);
});
